import * as React from "react";
import { type IColumn } from "@fluentui/react";
import { makeObservable, computed } from "mobx";
import { observer } from "mobx-react";
import { type UUID } from "../../utils/uuid";
import { type Vehicle, type VehicleDevice } from "../../api";

export interface ListVehicleDeviceItemCellProps {
    readonly vehicleDeviceId: UUID;
    readonly column: IColumn;
}

import { store } from "../../store";

@observer
export class ListVehicleDeviceItemCell extends React.Component<ListVehicleDeviceItemCellProps> {
    constructor(props: ListVehicleDeviceItemCellProps) {
        super(props);
        makeObservable(this);
    }

    @computed private get vehicle(): Vehicle | undefined {
        if (!this.vehicleDevice?.vehicleId) {
            return;
        }
        return store.repositoryVehicles.byId(this.vehicleDevice.vehicleId);
    }

    @computed private get vehicleDevice(): VehicleDevice | undefined {
        if (this.props.vehicleDeviceId === undefined) {
            return;
        }
        return store.repositoryVehicleDevices.byId(this.props.vehicleDeviceId);
    }

    /**
     * Compute the text for the vehicle link.
     * If any of the components is undefined, an empty string will be returned.
     */
    @computed private get vehicleText(): string {
        if (this.vehicleDevice === undefined || this.vehicle === undefined) {
            return "";
        }

        return store.i18n.formatVehicle(this.vehicle);
    }

    public render(): JSX.Element {
        const { column } = this.props;
        switch (column.key) {
            case "serialNumber":
                return <span>{this.vehicleDevice?.serialNumber}</span>;
            case "vehicleId":
                if (!this.vehicleText || !this.vehicle) {
                    return <span></span>;
                }
                return <span>{this.vehicle.serialNumber}</span>;
            case "createdAt":
                return (
                    <span>
                        {this.vehicleDevice
                            ? store.i18n.formatDateOnly(this.vehicleDevice.createdAt)
                            : ""}
                    </span>
                );
            case "firmwareLastUpdatedAt":
                return (
                    <span>
                        {this.vehicleDevice?.firmwareLastUpdatedAt
                            ? store.i18n.formatDateTime(this.vehicleDevice.firmwareLastUpdatedAt)
                            : ""}
                    </span>
                );
            case "currentFirmwareVersion":
                return <span>{this.vehicleDevice?.currentVersion ?? ""}</span>;
            default:
                return <></>;
        }
    }
}
